import { LoadingButton } from "@mui/lab"
import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from "@mui/material"
import { useEffect, useState } from "react"
import AutocompleteDeluxe from "../../components/AutocompleteDelux"
import Vista from "../../components/Vista"
import { useMessages } from "../../hooks/useMessages"
import Servo from "../../services/servo"

const hoy = () => new Date().toISOString().slice(0, 10)

const AsignacionesUnidad = () => {
  const { setMessages } = useMessages()
  const [usuario, setUsuario] = useState(null)
  const [carro, setCarro] = useState(null)
  const [fechaInicio, setFechaInicio] = useState(hoy())
  const [asignaciones, setAsignaciones] = useState([])
  const [guardando, setGuardando] = useState(false)

  const cargar = async () => {
    const respuesta = await Servo.get(
      "asignaciones-carros-usuarios?soloActivas=true&expand=usuario,carro&limite=200"
    )
    setAsignaciones(respuesta?.cuerpo?.resultado || [])
  }

  useEffect(() => {
    cargar()
  }, [])

  const enviarAsignacion = async (confirmarReasignacion = false) => {
    return Servo.post(
      "asignaciones-carros-usuarios/guardar",
      {
        idUsuario: usuario?.idUsuario,
        idCarro: carro?.idCarro,
        fechaInicio,
        confirmarReasignacion
      },
      "asignacionesUnidad",
      false
    )
  }

  const guardar = async () => {
    if (!usuario || !carro || !fechaInicio) {
      setMessages({ mensaje: "Seleccione usuario, unidad y fecha", color: "warning" })
      return
    }

    setGuardando(true)
    let respuesta = await enviarAsignacion(false)
    if (respuesta?.cuerpo?.detalle?.estatus === 409) {
      const confirmado = window.confirm(
        `Esta operación terminará una asignación vigente para asignar ${carro.economico} a ${usuario.nombreCompleto}. ¿Desea continuar?`
      )
      if (confirmado) respuesta = await enviarAsignacion(true)
    }

    if (respuesta?.cuerpo) setMessages(respuesta.cuerpo)
    if (respuesta?.cuerpo?.detalle?.estatus === 200) {
      setUsuario(null)
      setCarro(null)
      setFechaInicio(hoy())
      await cargar()
    }
    setGuardando(false)
  }

  const finalizar = async (asignacion) => {
    if (!window.confirm(`¿Finalizar la asignación de ${asignacion.usuario?.nombreCompleto || "este usuario"}?`)) return
    const respuesta = await Servo.post(
      "asignaciones-carros-usuarios/finalizar",
      {
        idAsignacionCarroUsuario: asignacion.idAsignacionCarroUsuario,
        fechaFin: hoy(),
        motivoFin: "Finalizada desde el módulo de asignación de unidad"
      },
      "asignacionesUnidad",
      false
    )
    if (respuesta?.cuerpo) setMessages(respuesta.cuerpo)
    if (respuesta?.cuerpo?.detalle?.estatus === 200) await cargar()
  }

  return (
    <Vista>
      <div style={{ padding: 24, width: "100%" }}>
        <h2 style={{ color: "#157CC1" }}>Asignación de unidades a usuarios</h2>
        <Paper style={{ padding: 20, marginBottom: 24 }}>
          <Grid container spacing={2} alignItems="end">
            <Grid item xs={12} md={4}>
              <AutocompleteDeluxe
                nombre="usuarios"
                dato={usuario}
                setDato={setUsuario}
                labelToShow="Usuario responsable"
                labelProp="nombreCompleto"
                idProp="idUsuario"
                required="true"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <AutocompleteDeluxe
                nombre="carros"
                dato={carro}
                setDato={setCarro}
                labelToShow="Unidad"
                labelProp="economico"
                concat="placas"
                idProp="idCarro"
                required="true"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                type="date"
                label="Fecha de asignación"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <LoadingButton fullWidth variant="contained" loading={guardando} onClick={guardar}>
                ASIGNAR
              </LoadingButton>
            </Grid>
          </Grid>
        </Paper>

        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Usuario responsable</TableCell>
                  <TableCell>Unidad</TableCell>
                  <TableCell>Placas</TableCell>
                  <TableCell>Fecha de asignación</TableCell>
                  <TableCell align="right">Acción</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {asignaciones.map((asignacion) => (
                  <TableRow key={asignacion.idAsignacionCarroUsuario}>
                    <TableCell>{asignacion.usuario?.nombreCompleto || asignacion.idUsuario}</TableCell>
                    <TableCell>{asignacion.carro?.economico || asignacion.idCarro}</TableCell>
                    <TableCell>{asignacion.carro?.placas || "—"}</TableCell>
                    <TableCell>{asignacion.fechaInicio}</TableCell>
                    <TableCell align="right">
                      <Button color="error" variant="outlined" onClick={() => finalizar(asignacion)}>
                        Finalizar
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
                {!asignaciones.length && (
                  <TableRow><TableCell colSpan={5} align="center">No hay asignaciones activas.</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </Vista>
  )
}

export default AsignacionesUnidad
